import React from "react";
import PropTypes from "prop-types";
import { noPaddingAllTypes } from "../../constants";

class Container extends React.Component {
  render() {
    const padding = this.props.padding ? `padding-${this.props.padding}` : "";
    const flex = this.props.flex ? "flex" : "";
    const fluid = this.props.fluid ? "fluid" : "";
    const className = this.props.className ? this.props.className : "";

    const cssClasses = `container ${padding} ${flex} ${fluid} ${className}`;

    return React.createElement(
      "div",
      {
        className: cssClasses
      },
      this.props.children
    );
  }
}

Container.defaultProps = {
  padding: null,
  flex: false,
  fluid: false,
  className: "",
  children: null
};

Container.propTypes = {
  padding: PropTypes.oneOf(noPaddingAllTypes),
  flex: PropTypes.bool,
  fluid: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
};

export default Container;
